import { Injectable, Inject } from 'ng-metadata/core';
import {HttpService} from '../../../../infra/httpRequest/http.service';

@Injectable()
export class GetItRequestService {
    
    private primaBaseUrl:any;
    private ilsServices:object={};
    
	constructor (private httpService: HttpService,
				 @Inject('restBaseURLs') private restBaseURLs,
				 @Inject('$q') private $q: ng.IQService) {
					this.primaBaseUrl = restBaseURLs.requestStatusMapURL;
					this.ilsServices = {
                            '/requestFormMessage': {
                                'path': restBaseURLs.requestFormMessageURL,        
                                'method': 'GET'
                            }

                    }; 
	}

	private resquestInProgress:Object = {};

    public getRequestFormMessage(requestype){
        let params = {requestype: requestype};   
        return this.makeIlsRequest('/requestFormMessage', params);
    }

    public getServices(){
        return this.ilsServices;
	}
	
	makeIlsRequest(serviceName: string, params: Object){
        if(!params){
            params= {};
        }
        let ngrsService = this.ilsServices[serviceName];
        this.resquestInProgress[serviceName] = true;

        return this.httpService.call(ngrsService.method, ngrsService.path, params)
            .then(
                (response)=> {
                    return this.ilsRequestSuccess(response);
                },
                (error)=>{
                    return this.ilsRequestFailure(error, serviceName, params);
                }
            ).finally( () =>
                this.resquestInProgress[serviceName] = false
            );
    }
    
	get requestInProgress(){
        return this.resquestInProgress || false;
    }

    private ilsRequestSuccess(response){
        return response;
    }

    private ilsRequestFailure(reason, serviceName, params) {
        console.error(reason, serviceName);
        return reason;
    }  
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/getItRequest/getItRequest.service.ts